// Plantillas de partida (starter prompts) para el copilot de Mensajería.
// Cada plantilla pre-llena los campos del formulario y deja al equipo solo
// ajustar el detalle puntual. NO son contenido final: son disparadores.

export const TEMPLATES = [
  {
    id: 'speech-asuncion',
    title: 'Discurso de asunción / sesión preparatoria',
    type: 'speech',
    channel: null,
    audience: 'all',
    tone: 'inspiring',
    topic: 'Asunción como concejal · plan de mandato 2025-2029',
    details:
      'Mencioná: agradecimiento al electorado de San Nicolás, reconocimiento a la militancia de LLA y Primero San Nicolás, ' +
      'compromiso con humedales + transparencia + planificación a 20 años. Cerrá con el pedido a colegas del Concejo de ' +
      'trabajar en proyectos concretos antes que en peleas mediáticas.',
    icon: '🎤',
  },
  {
    id: 'press-proyecto-ordenanza',
    title: 'Comunicado de prensa · presentación de ordenanza',
    type: 'press',
    channel: null,
    audience: 'press',
    tone: 'formal',
    topic: 'Presentación de proyecto de ordenanza',
    details:
      'Estructura tipo gacetilla: lugar/fecha (San Nicolás de los Arroyos, [FECHA]), titular en negativo (qué problema resuelve), ' +
      '2 párrafos con detalles del proyecto, 1 cita textual del concejal, otra cita técnica si aplica, contacto de prensa al final. ' +
      'Reemplazá [INSERTAR] con datos puntuales del proyecto: nombre, número de expediente, área de gestión.',
    icon: '📄',
  },
  {
    id: 'social-x-post-rapido',
    title: 'Post X / Twitter · reacción de coyuntura',
    type: 'social',
    channel: 'twitter',
    audience: 'all',
    tone: 'conversational',
    topic: 'Reacción a hecho de coyuntura local',
    details:
      'Máximo 280 caracteres. Hook directo en la primera línea. NO uses emojis. ' +
      'Sugerencia de hashtags: #SanNicolás #LLA #Concejo. Si el hecho involucra a un competidor, contrastá con datos, ' +
      'no con insultos.',
    icon: '🐦',
  },
  {
    id: 'social-instagram-foto',
    title: 'Caption Instagram · foto de actividad',
    type: 'social',
    channel: 'instagram',
    audience: 'youth',
    tone: 'conversational',
    topic: 'Caption para foto de recorrida o evento',
    details:
      'Caption ≤ 2200 chars. Primer línea como hook (lo que se ve antes del "ver más"). 4-6 hashtags al final. ' +
      'Tono cercano, primera persona singular. Mencioná barrio o lugar específico.',
    icon: '📷',
  },
  {
    id: 'social-linkedin-empresarios',
    title: 'Post LinkedIn · audiencia empresarial',
    type: 'social',
    channel: 'linkedin',
    audience: 'business',
    tone: 'technical',
    topic: 'Posicionamiento sobre desarrollo económico local',
    details:
      'Tono profesional, 600-1200 caracteres. Apoyate en credenciales propias (Director MoviPort, Pdte. Fundación MoviPort). ' +
      'Cerrá con una pregunta abierta para generar engagement con empresarios y PyMEs locales.',
    icon: '💼',
  },
  {
    id: 'email-base-militante',
    title: 'Email · base militante',
    type: 'email',
    channel: null,
    audience: 'militants',
    tone: 'conversational',
    topic: 'Update mensual de la actividad legislativa',
    details:
      'Asunto corto y orientado a la acción. Saludo informal. 3 párrafos: (1) qué se trabajó este mes, (2) próximos pasos, ' +
      '(3) cómo pueden colaborar. Firma con nombre y rol.',
    icon: '📧',
  },
  {
    id: 'talking-debate-presupuesto',
    title: 'Talking points · debate de presupuesto municipal',
    type: 'talking',
    channel: null,
    audience: 'press',
    tone: 'technical',
    topic: 'Debate de presupuesto municipal en el Concejo',
    details:
      '5-7 mensajes principales, cada uno con 1-2 sub-puntos numéricos cuando sea posible. Foco en: tasas, partidas a obras, ' +
      'transparencia, déficit/superávit. Evitá sloganes — esto es para responder rápido en cámara.',
    icon: '🗣️',
  },
  {
    id: 'press-respuesta-acusacion',
    title: 'Comunicado · respuesta a acusación',
    type: 'press',
    channel: null,
    audience: 'press',
    tone: 'formal',
    topic: 'Respuesta a acusación o ataque mediático',
    details:
      'Tono firme, sin agresión. Estructura: (1) qué se dijo y dónde, (2) datos que desmienten, (3) intencionalidad política ' +
      'detrás (si aplica), (4) cierre constructivo invitando al debate de propuestas.',
    icon: '🛡️',
  },
  {
    id: 'social-tiktok-vertical',
    title: 'Guión TikTok · video corto vertical',
    type: 'social',
    channel: 'tiktok',
    audience: 'youth',
    tone: 'conversational',
    topic: 'Guión para video de 30 segundos',
    details:
      'Estructura: hook 0-3 seg ("¿Sabías que…"), desarrollo 3-25 seg con 2-3 datos, CTA 25-30 seg ("seguime para más"). ' +
      'Indicaciones de cámara entre [corchetes] cuando aplique. Caption ≤ 150 chars con 3 hashtags.',
    icon: '🎬',
  },
];

export const TYPE_OPTIONS = [
  { value: 'speech', label: 'Discurso' },
  { value: 'press', label: 'Comunicado de prensa' },
  { value: 'social', label: 'Post de redes' },
  { value: 'email', label: 'Email' },
  { value: 'talking', label: 'Talking points' },
  { value: 'document', label: 'Documento / nota' },
];

export const CHANNEL_OPTIONS = [
  { value: '', label: '— sin canal específico —' },
  { value: 'twitter', label: 'X / Twitter (≤280 chars)' },
  { value: 'instagram', label: 'Instagram (caption)' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'tiktok', label: 'TikTok (caption ≤150)' },
];

export const AUDIENCE_OPTIONS = [
  { value: 'all', label: 'General de San Nicolás' },
  { value: 'youth', label: 'Jóvenes 16-29' },
  { value: 'seniors', label: 'Adultos mayores 60+' },
  { value: 'workers', label: 'Trabajadores' },
  { value: 'business', label: 'Empresarios / PyMEs' },
  { value: 'press', label: 'Prensa / medios' },
  { value: 'militants', label: 'Base militante' },
];

export const TONE_OPTIONS = [
  { value: 'formal', label: 'Formal' },
  { value: 'conversational', label: 'Conversacional' },
  { value: 'inspiring', label: 'Inspirador' },
  { value: 'technical', label: 'Técnico' },
  { value: 'emotional', label: 'Emotivo' },
];

const CHANNEL_LIMITS = {
  twitter: 280,
  instagram: 2200,
  linkedin: 3000,
  tiktok: 150,
  facebook: 5000,
};
export function channelCharLimit(channel) {
  return CHANNEL_LIMITS[channel] || null;
}
